import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import MainContect from './Context/MainContect';
import ReactGA from "react-ga4";
import 'aos/dist/aos.css'


ReactGA.initialize("G-XXXXXXXXXX"); 
ReactGA.send("pageview");
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    
    <MainContect>
      <App />
    </MainContect>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
